import React, { createContext, useContext } from 'react';

import { IPaymentMethod } from 'state/payment/types';

import { useFeatureScanAndPay } from '../hooks/use-feature-scan-and-pay';
import { useScanAndPay } from '../hooks/use-scan-and-pay';
import { IScanAndPayTextContent } from '../types';

export interface IScanAndPayContext {
  loadingSelectedPaymentMethod: boolean;
  loadingStatus: boolean;
  nonSelectedPaymentMethods: IPaymentMethod[];
  scanAndPayContent: IScanAndPayTextContent;
  scanAndPayContentLoading: boolean;
  scanAndPayEnabledForUser: boolean;
  selectedPaymentMethod?: IPaymentMethod;
  selectedPaymentMethodId: string;
  updateScanAndPayStatus(newStatus: boolean, defaultPaymentMethodId?: string): void;
  updateSelectedScanAndPayPaymentMethod(newPaymentMethodId: string): void;
  updatingSelectedPaymentMethod: boolean;
  updatingStatus: boolean;
  userHasValidScanAndPayPaymentMethodOption: boolean;
}

export const ScanAndPayContext = createContext<IScanAndPayContext>({} as IScanAndPayContext);

export const useScanAndPayContext = () => useContext(ScanAndPayContext);

export const ScanAndPayProvider: React.FC = ({ children }) => {
  const { scanAndPayContent, loading: scanAndPayContentLoading } = useFeatureScanAndPay();

  const {
    loadingStatus,
    scanAndPayEnabledForUser,
    updateScanAndPayStatus,
    updatingStatus,

    loadingSelectedPaymentMethod,
    nonSelectedPaymentMethods,
    selectedPaymentMethod,
    selectedPaymentMethodId,
    updateSelectedScanAndPayPaymentMethod,
    updatingSelectedPaymentMethod,
    userHasValidScanAndPayPaymentMethodOption,
  } = useScanAndPay();

  const scanAndPayTextContent: IScanAndPayTextContent = {
    header: scanAndPayContent?.header?.locale,
    inactiveStateBody: scanAndPayContent?.inactiveStateText?.locale,
    noPaymentMethodStateBody: scanAndPayContent?.addNewPaymentMethodStateText?.locale,
  };

  return (
    <ScanAndPayContext.Provider
      value={{
        loadingSelectedPaymentMethod,
        loadingStatus,
        nonSelectedPaymentMethods,
        scanAndPayContent: scanAndPayTextContent,
        scanAndPayContentLoading,
        scanAndPayEnabledForUser,
        selectedPaymentMethod,
        selectedPaymentMethodId,
        updateScanAndPayStatus,
        updateSelectedScanAndPayPaymentMethod,
        updatingSelectedPaymentMethod,
        updatingStatus,
        userHasValidScanAndPayPaymentMethodOption,
      }}
    >
      {children}
    </ScanAndPayContext.Provider>
  );
};
